import Application from "../../Application";
import DevicePresenter, {
  IDevicePresenter
} from "../../presenter/device/DevicePresenter";
import { IDevice } from "../../model/device/Device";
import TDevicePresentationModel from "../../presenter/device/model/DevicePresentationModel";
import { UserPreferences } from "../../common/Constants";

export default class ShowDevicesInteractor {
  private application: Application;
  private output?: IDevicePresenter;

  constructor({ application }: { application: Application }) {
    this.application = application;
  }

  DevicePresentationModelMapper = (devices: IDevice[]) => {
    return devices.map((device) => {
      return TDevicePresentationModel(device);
    });
  };

  execute(devices: IDevice[]) {
    this.output = DevicePresenter({
      application: this.application,

      initialState: {
        devices: this.DevicePresentationModelMapper(devices || []),
        modalVisible: false,
        username: "",
        password: "",
        loginButtonDisabled: true
      }
    });

    this.application.container.registerValue(
      "language",
      window.localStorage.getItem("language") ||
        UserPreferences.DEFAULT_LANGUAGE
    );

    return this.output;
  }
}
